module.exports = __webpack_public_path__ + "static/img/BottomBackground.8222496.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/BottomBackground.png
// module id = Qa7B
// module chunks = 44